import PusherPkg from "pusher-js";
import { createConsola } from "consola";
import { useEchoConfig } from "./composables/useEchoConfig.js";
import { useEchoAppConfig } from "./composables/useEchoAppConfig.js";
import { createEcho } from "./factories/echo.js";
import { defineNuxtPlugin, updateAppConfig } from "#app";
const Pusher = PusherPkg.default || PusherPkg;
const MODULE_NAME = "nuxt-laravel-echo";
function createEchoLogger(logLevel) {
  return createConsola({ level: logLevel }).withTag(MODULE_NAME);
}
async function setupDefaultTokenStorage(nuxtApp, logger) {
  logger.debug(
    "Token storage is not defined, switch to default cookie storage"
  );
  const defaultStorage = await import("./storages/cookieTokenStorage.js");
  nuxtApp.runWithContext(() => {
    updateAppConfig({
      echo: {
        tokenStorage: defaultStorage.cookieTokenStorage
      }
    });
  });
}
export default defineNuxtPlugin(async (_nuxtApp) => {
  const nuxtApp = _nuxtApp;
  const config = useEchoConfig();
  const appConfig = useEchoAppConfig();
  const logger = createEchoLogger(config.logLevel);
  if (config.authentication?.mode === "token" && !appConfig.tokenStorage) {
    await setupDefaultTokenStorage(nuxtApp, logger);
  }
  window.Pusher = Pusher;
  window.Echo = createEcho(nuxtApp, config, logger);
  logger.debug("Laravel Echo client initialized");
  return {
    provide: {
      echo: window.Echo
    }
  };
});
